import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { InHomeCareLicenseService } from "app/services/license/in-home-care/in-home-care-license.service";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({ providedIn: 'root' })

export class IhcNameValidator implements AsyncValidator {
  licenseId: string = '';

  constructor(private service: InHomeCareLicenseService){}

  validate(
    control: AbstractControl
  ): Observable< ValidationErrors | null > {
    return this.service.checkIfNameValid(control.value, this.licenseId).pipe(
      map(valid => (
        !valid ? { invalidName: true} : null
        )),
      catchError(() => of(null))
    )
  }
}
